import * as React from "react";
import { Button } from '../library/Button';
import { ComponentImage } from '../library/ComponentImage';

const COMPONENT_NAME = "Header";

export class Header extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="Header">
                <div className="topbar">
                    <ComponentImage
                        className="edge-left" 
                        component={COMPONENT_NAME}
                        file="topbar-edge-left.png"
                    />
                    <div className="fill" />
                    <ComponentImage
                        className="edge-right" 
                        component={COMPONENT_NAME}
                        file="topbar-edge-left.png"
                    />
                </div>
                <div className="logo">
                    <div className="sprite">
                        <div className="glow" />
                        <div className="glow" />
                        <ComponentImage
                            className="image"
                            component={COMPONENT_NAME}
                            file="logo-large.png"
                        />
                    </div>
                    <div className="warp">
                        Warp
                    </div>
                    <ComponentImage
                        className="icon"
                        component={COMPONENT_NAME}
                        file="logo-animated.gif"
                    />
                    <div className="prism">
                        Prism
                    </div>
                    <div className="tagline">
                        Fast stream watching
                    </div>
                </div>
                <div className="infobar">
                    <div>
                        <script type="text/javascript" src="//www.redditstatic.com/button/button1.js"></script>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./react/components/Header.jsx